import {useDebugValue} from 'react';

import {noop} from '../../../utils/noop';

import {useEvents} from './useEvents';

const defaultDestinationEvents = {
    onSettingsChange: noop,
    onCurrentValuesChange: noop,
    onLatestValuesChange: noop,
    onBlur: noop,
    onFocus: noop,
    onMount: noop,
    onSearchSelected: noop
};

function useDestinationEvents(props) {
    const {
        destinationEvents: propsDestinationEvents
    } = props;

    const {
        events: destinationEvents
    } = useEvents(defaultDestinationEvents, propsDestinationEvents);

    const result = {
        destinationEvents
    };

    useDebugValue(result);

    return result;
}

export {useDestinationEvents};
